import { httpClient } from "../../services/httpClient";

type TParams = {
  key: string;
  value: string;
};

export const downloadFile = ({
  url,
  params,
}: {
  url: string;
  params?: TParams[];
}) => {
  const formData = new FormData();
  params?.map((it) => {
    formData.append(it.key, it.value);
  });
  return httpClient.post(url, formData ? formData : null, {
    responseType: "blob",
  });
};
